import React, { Component } from "react";
import "./SingleWarranty.css";
import "../../common.css";
import apiEndpoints from "@store/apiEndpoints";
import LoadingPage from "@components/Loading/Loading";
import Tabs from "@components/Tabs/Tabs";
import errorFunctions from "@store/errorFunctions";
import Modal from "react-modal";
// import { Redirect } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "./SingleWarranty.css";
import Repair from "./Repair/Repair";
import CustomerInfo from "./CustomerInfo/CustomerInfo";
import DeliveryAddress from "./DeliveryAddress/DeliveryAddress";
import DeviceDetails from "./DeviceDetails/DeviceDetails";
import Activities from "./Activities/Activities";
import TicketProcess from "./TicketProcess/TicketProcess";
import CommercialNotes from "./CommercialNotes/CommercialNotes";
import EmailLogs from "./EmailLogs/EmailLogs";
import StepperHorizontal from "@components/Stepper/StepperHorizontal";
import ErrorPage from "@pages/ErrorPage/ErrorPage";
import config from "@config";
Modal.setAppElement("body");

const inWarrantySteps = {
  Approved: {
    next: "Under review",
    buttonText: "Mark as received",
    modalText: "Confirm that you have received the item.",
  },
  "In transit": {
    next: "Under review",
    buttonText: "Mark as received",
    modalText: "Confirm that you have received the item.",
  },
  "Under review": {
    next: "Under servicing",
    buttonText: "Review complete - mark as under service",
    modalText: "Confirm that item is ready to be serviced.",
  },
  "Under servicing": {
    next: "Complete",
    buttonText: "Mark as completed",
    modalText: "Confirm that item is ready to be sent to customer.",
  },
  Complete: {},
};
const outOfWarrantySteps = {
  Approved: {
    next: "Under review",
    buttonText: "Mark as received",
    modalText: "Confirm that you have received the item.",
  },
  "In transit": {
    next: "Under review",
    buttonText: "Mark as received",
    modalText: "Confirm that you have received the item.",
  },
  "Under review": {},
  "Approve invoice": {
    next: "Under servicing",
    buttonText: "Payment received - mark as under service",
    modalText: "Confirm that item is ready to be serviced.",
  },
  "Awaiting payment": {
    next: "Under servicing",
    buttonText: "Payment received - mark as under service",
    modalText: "Confirm that item is ready to be serviced.",
  },
  "Under servicing": {
    next: "Complete",
    buttonText: "Mark as completed",
    modalText: "Confirm that item is ready to be sent to customer.",
  },
  Complete: {},
};

export default class SingleWarranty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      details: null,
      // userDevice: null,
      redirect: false,
      employee: null,
      statusTicket: "",
      statusTicketType: "",
      typeService: "",
      reportCount: 0,
      defaultTab: null,
      employees: [],
      serviceCenterLocations: [],
      locationOptions: [],
      serviceCenterCentrals: [],
      optionServiceCenterLocations: [],
      optionServiceCenterCentrals: [],
      optionEmployees: [],
      isShowRepair: false,
      isCommercial: false,
      ticketIsSameCountry: false,
    };
  }
  ticketId = this.props.computedMatch?.params.id;
  componentDidMount() {
    this.retrieveEmployeeList();
    this.retrieveWarranty(this.ticketId);
    this.retriveDevices();
  }

  retrieveServiceCenterCentral = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        apiEndpoints.serviceCenterCentral.dropdown(),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        // const scc =
        //   config.country === "NZ"
        //     ? res?.filter((s) => s.name.includes("NZ"))
        //     : res?.filter((s) => !s.name.includes("NZ"));
        //do not show email with @treeclouds.com and @karadigital.co
        const optionServiceCenters = (Array.isArray(res) ? res : []).map(
          (s) => {
            return {
              value: s.id,
              label: s.name,
              isDisabled: s.name.includes("PTC"),
            };
          },
        );

        this.setState({
          loading: false,
          serviceCenterCentrals: res,
          // serviceCenters: serviceCenters,
          optionServiceCenterCentrals: [
            ...[{ value: 0, label: "Select.." }],
            ...optionServiceCenters,
          ],
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };
  retrieveServiceCenterLocation = (id) => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        apiEndpoints.serviceCenterCentral.locationDropdown(id),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        //do not show email with @treeclouds.com and @karadigital.co
        const hiddenServiceCenter = "PTC Midland Gate";
        const optionServiceCenterLocations = (Array.isArray(res) ? res : [])
          .filter((s) => s.name !== hiddenServiceCenter)
          .map((s) => {
            return { value: s.id, label: s.name };
          });

        this.setState({
          loading: false,
          serviceCenterLocations: res,
          // serviceCenters: serviceCenters,
          optionServiceCenterLocations: [
            ...[{ value: 0, label: "Select.." }],
            ...optionServiceCenterLocations,
          ],
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  retrieveStoreLocation = (brandId) => {
    this.setState({
      isLoading: true,
    });
    this.props
      .protectedFetch(
        apiEndpoints.storeLocation.dropdown(),
        "GET",
        { brandId: brandId || "" },
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const options = res.map((r) => {
          return { label: r.seller_name + " - " + r.name, value: r.id };
        });
        this.setState({
          isLoading: false,
          locationOptions: [...options],
        });
      })
      .catch((err) => console.log(err));
  };

  retrieveWarranty = async (id) => {
    this.setState({ loading: true });
    const isContractor = this.props.userInfo?.user.role === "Contractor";
    await this.props
      .protectedFetch(
        isContractor
          ? apiEndpoints.ticket.contractorDetail(id)
          : apiEndpoints.ticket.detail(id),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const ticketCountry = res?.user_device?.device?.brand?.country;
        const isWrongCountry =ticketCountry !== config.country
        if (isWrongCountry) {
          this.setState({ loading: false, ticketIsSameCountry: true });
          return;
        }

        const goodsReceived = "Pending Receipt of Goods";
        const idxGoodReceived = res.ticket_status_list?.findIndex((x) =>
          x.toLowerCase().includes(goodsReceived.toLowerCase()),
        );
        const idCurrentStatus = res.ticket_status_list?.findIndex(
          (x) => x === res.status,
        );
        const isShowRepair = idCurrentStatus > idxGoodReceived;
        let count = -1;
        if (res.diagnostic_report.length > 0) count = 0;
        if (res.repair_report.length > 0) count = 1;
        if (res.quality_check_report.length > 0) count = 2;
        // console.log(res);this.st
        if (this.state.serviceCenterCentrals.length === 0) {
          this.retrieveServiceCenterCentral();
        }

        if (res.service_center_central)
          this.retrieveServiceCenterLocation(res.service_center_central);
        const isCommercial = ["Commercial Staff", "Commercial Admin"].includes(
          this.props.userInfo?.user.role,
        );
        const isContractor = ["Contractor"].includes(
          this.props.userInfo?.user.role,
        );

        this.setState({
          loading: false,
          details: res,
          isShowRepair: isShowRepair,
          isCommercial,
          isContractor,
          defaultTab: isCommercial ? "Communications" : "Activity",

          reportCount: count,
        });
        this.retrieveStoreLocation(res?.user_device?.device?.brand?.id || "");
      })
      .catch((err) => {
        const status = err?.status || err?.response?.status;
        if (status === 403 || status === 404) {
          this.setState({ loading: false, ticketIsSameCountry: true });
        } else {
          this.setState({ loading: false });
        }
        console.log("fail", err);
      });
  };

  retrieveEmployeeList = () => {
    this.props
      .protectedFetch(
        apiEndpoints.employee.dropdown(),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const sortEmp = res.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
        );
        this.setState({ employee: sortEmp });
        this.setState({
          employees: sortEmp,
        });
      })
      .catch(() => {
        console.log("fail");
      });
  };

  retriveDevices() {
    this.props
      .protectedFetch(
        apiEndpoints.device.dropdown(),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const deviceOptions = res.map((val) => {
          return { label: val.name, value: val.id };
        });
        this.setState({
          isLoading: false,
          deviceOptions,
        });
      });
  }

  render() {
    if (this.state.loading) {
      return <LoadingPage />;
    }

    if (this.state.ticketIsSameCountry) {
      return (
        <ErrorPage
          statusCode={403}
          title="Access Restricted"
          message="This ticket belongs to a different region and cannot be accessed from your current portal."
          buttonText="Back to Tickets"
          onBack={() => {
            window.location.href = "/tickets";
          }}
        />
      );
    }

    // const details = this.state.details || {};
    const warrantySteps = this.state.details?.out_of_warranty
      ? outOfWarrantySteps
      : inWarrantySteps;
    const optionEmployees = this.state.serviceCenters
      ?.find((x) => x.id === this.state.details?.service_center)
      ?.staff?.map((s) => {
        return { value: s.employee, label: s.name };
      });

    return (
      <div className={"page"}>
        {!this.state.details && <ErrorPage statusCode={404} />}
        {this.state.isCommercial && (
          <div className="card mb-3">
            <div className="card-header">
              <div className="row">
                <span className="col">Ticket Statuses</span>
              </div>
            </div>
            <div className="card-body">
              <StepperHorizontal
                returnLabelLink={
                  this.state.serviceCenterLocations?.return_label_link
                }
                returnLabelPDF={this.state.details?.return_label}
                stepList={this.state.details?.ticket_status_list}
                statuses={this.state.details?.ticket_status}
                statusLabels={this.state.details?.status_labels}
              />
            </div>
          </div>
        )}

        <div className="row">
          <div
            className="col-md-4"
            style={{
              maxHeight: "calc(100vh - 100px)",
              overflowY: "auto",
              position: "sticky",
              top: "0",
            }}
          >
            {!this.state.isContractor && (
              <TicketProcess
                details={this.state.details}
                warrantySteps={warrantySteps}
                userInfo={this.props.userInfo}
                employees={this.state.employees}
                optionEmployees={optionEmployees}
                serviceCenterLocations={this.state.serviceCenterLocations}
                serviceCenterCentrals={this.state.serviceCenterCentrals}
                optionServiceCenterCentrals={
                  this.state.optionServiceCenterCentrals
                }
                optionServiceCenterLocations={
                  this.state.optionServiceCenterLocations
                }
                locationOptions={this.state.locationOptions}
                deviceOptions={this.state.deviceOptions}
                protectedFetch={this.props.protectedFetch}
                retrieveServiceCenter={() =>
                  this.retrieveServiceCenterCentral()
                }
                selectedbrandID={this.props.selectedbrandID}
                // retrieveServiceCenterLocation={(id) => this.retrieveServiceCenterLocation(id)}
                retrieveWarranty={() => this.retrieveWarranty(this.ticketId)}
              />
            )}

            {!this.state.isContractor && (
              <DeliveryAddress
                details={this.state.details}
                protectedFetch={this.props.protectedFetch}
                userInfo={this.props.userInfo}
                retrieveWarranty={() => this.retrieveWarranty(this.ticketId)}
              />
            )}

            {!this.state.isContractor ? (
              <CustomerInfo details={this.state.details} />
            ) : (
              <div className="card mb-2">
                <div className="card-header">
                  <span>
                    <b>Ticket# :</b>
                  </span>{" "}
                  <span>{this.state.details.ticket_number}</span>
                </div>
                <div className="card-body">
                  <div>
                    <span>
                      <b>Owner Name: </b>
                    </span>
                    <span>{this.state.details?.user_device?.name}</span>
                  </div>
                  <div className="mt-2">
                    <span>
                      <b>Ticket Status: </b>
                    </span>
                    <span>
                      {this.state.details?.status_label ||
                        this.state.details?.status}
                    </span>
                  </div>
                </div>
              </div>
            )}

            <DeviceDetails
              details={this.state.details}
              protectedFetch={this.props.protectedFetch}
              userInfo={this.props.userInfo}
              retrieveWarranty={() => this.retrieveWarranty(this.ticketId)}
            />
          </div>
          <div className="col-md-8">
            <Tabs
              defaultTab={this.state.defaultTab}
              resetTab={() => this.setState({ defaultTab: undefined })}
            >
              <div label="Activity" disabled={this.state.isCommercial}>
                <Activities
                  userInfo={this.props.userInfo}
                  isHeadless={this.state.isContractor}
                  details={this.state.details}
                  protectedFetch={this.props.protectedFetch}
                  retrieveWarranty={() => this.retrieveWarranty(this.ticketId)}
                />
              </div>
              <div label="Repair Details" disabled={this.state.isCommercial}>
                <Repair
                  device={this.state.details?.user_device.device}
                  reportCount={this.state.reportCount}
                  protectedFetch={this.props.protectedFetch}
                  ticketId={this.ticketId}
                  ticketDetails={this.state.details}
                  employeeList={this.state.employees?.filter(
                    (e) => e?.user_role === "Service",
                  )}
                  retrieveWarranty={() => this.retrieveWarranty(this.ticketId)}
                  selectedbrandID={this.props.selectedbrandID}
                  setDefaultTab={() =>
                    this.setState({ defaultTab: "Repair Details" })
                  }
                  isShowRepair={
                    this.state.isShowRepair && !this.state.isContractor
                  }
                  userInfo={this.props.userInfo}
                />
              </div>

              <div
                label="Communications"
                disabled={this.state.isContractor || this.state.isCommercial}
              >
                <CommercialNotes
                  userInfo={this.props.userInfo}
                  details={this.state.details}
                  protectedFetch={this.props.protectedFetch}
                  retrieveWarranty={() => this.retrieveWarranty(this.ticketId)}
                  setDefaultTab={() =>
                    this.setState({ defaultTab: "Communications" })
                  }
                />
              </div>

              <div
                label="Email Logs"
                disabled={this.state.isContractor || this.state.isCommercial}
              >
                <EmailLogs
                  userInfo={this.props.userInfo}
                  protectedFetch={this.props.protectedFetch}
                  ticketId={this.ticketId}
                  customerEmail={this.state.details?.customer?.email}
                />
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
